import React from 'react';

const EventContext = React.createContext({
    eventTriggered: false,
    closeTriggered: false,
    triggerEvent: () => {},
    closeEvent: () => {},
});

export default EventContext;